import { useAppSelector } from 'store/hooks';
import * as selectUser from 'store/user/user.selector';

/**
 * Admin da plataforma — inclusive vendo a conta de um cliente pelo "Acessar
 * como" (out/2026, pedido do Bruno: o admin impersonando precisa das mesmas
 * funções de admin; o Excel de auditoria sumia porque o `currentUser` passa a
 * ser o cliente). O backend confere o admin do token (`req.adminId`); aqui é só
 * exibição.
 */
export const useIsAdmin = (): boolean => {
  const user = useAppSelector(selectUser.currentUser);
  const isImpersonating = useAppSelector(selectUser.isImpersonating);
  return !!user?.isAdmin || isImpersonating;
};
